import "../itemlist/itemlist.css";
import React, {
  useEffect,
  useState,
  useRef,
  useEffect as ReactUseEffect,
} from "react";
import { Container, Image } from "react-bootstrap";
import HlsPlayer from "../hlsplayer/HlsPlayer";

export const ItemList = ({ catid, onHover }) => {
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [overlayOpen, setOverlayOpen] = useState(false);

  const [currentPlaying, setCurrentPlaying] = useState(null); // track which video is playing
  const [errorVideo, setErrorVideo] = useState(null); // track error video

  useEffect(() => {
    fetch(`https://dispatch.whizti.com/api/category/${catid}`)
      .then((response) => response.json())
      .then((json) => {
        setVideos(json);
      });
  }, [catid]);

  const videoList = videos?.response?.content;

  // Lock page scroll when overlay is open
  ReactUseEffect(() => {
    document.body.style.overflow = overlayOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [overlayOpen]);

  const openPlayer = (video) => {
    setSelectedVideo(video.uri);
    setOverlayOpen(true);
    setCurrentPlaying(video.id);
    setErrorVideo(null);
  };

  const closePlayer = () => {
    setOverlayOpen(false);
    setSelectedVideo(null);
    setCurrentPlaying(null);
  };

  const handlePlayerError = () => {
    setErrorVideo(currentPlaying);
    setCurrentPlaying(null);
  };

  const handleClick = (video) => {
    setCurrentPlaying(video.id);

    onHover?.(video); // still notify parent
  };
  const containerRef = useRef(null);

  const scrollLeft = () => {
    containerRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    containerRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  const playerContainerRef = useRef(null);

  useEffect(() => {
    if (overlayOpen && playerContainerRef.current) {
      // playerContainerRef.current.requestFullscreen?.().catch(() => {});
    }
  }, [overlayOpen]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && closePlayer();
    if (overlayOpen) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [overlayOpen]);

  return (
    <div className="video-wrapper">
      {/* Left Arrow */}
      {/* <button className="scroll-btn left" onClick={scrollLeft}>
        ◀
      </button> */}
      <button className="scroll-btn left" onClick={scrollLeft}>
        &#8668;
      </button>

      <Container
        fluid
        className="flex-container flex-nowrap"
        ref={containerRef}
      >
        {videoList?.length ? (
          videoList.map((video) => (
            <div key={video.id}>
              <div className="list" onClick={() => handleClick(video)}>
                <div className="thumbnail-wrapper relative">
                  <Image src={video.icon_uri} className="thumbnail" />
                  <div className="play-button"></div>

                  {/* ✅ BADGES */}
                  {currentPlaying === video.id && (
                    <span className="badge badge-playing">🎵 Now Playing</span>
                  )}
                  {errorVideo === video.id && (
                    <span className="badge badge-error">⚠ Media Error</span>
                  )}
                </div>
                <div>
                  <h6 className="truncated-text">{video.title}</h6>
                </div>
              </div>
            </div>
          ))
        ) : (
          <span>No videoList found</span>
        )}
      </Container>

      {/* Right Arrow */}
      <button className="scroll-btn right" onClick={scrollRight}>
        {/* ▶ */} &#8669;
      </button>

      {/* Fullscreen overlay */}
      {overlayOpen && selectedVideo && (
        <div className="player-overlay" role="dialog" aria-modal="true">
          <div className="player-backdrop" onClick={closePlayer} />
          <div className="player-content" ref={playerContainerRef}>
            <button
              className="player-close"
              onClick={closePlayer}
              aria-label="Close player"
            >
              ✕
            </button>

            <HlsPlayer
              src={selectedVideo}
              autoPlay
              controls
              onError={handlePlayerError}
            />
          </div>
        </div>
      )}
    </div>
  );
};
